export default {
  SettingOrderSourceStrategyParcel: {
    title: '单品发货',
    rule: '新增规则',
    condition: '排除条件设置',
    pack: '包裹规则发货设置',
    hint1: '填数量，则按SKU指定数量分包',
    hint2: '不填数量不限制，则按SKU维度分包',
    unlimited: '不限',
    all: '全部',
    batchDeletion: '批量删除',
    rejectText: '分包数量不能为0，请重新输入',
    confirmText1: '保存后已匹配包裹规则的订单不受影响，未匹配的订单将会按照新包裹规则拆分，确定要保存吗？',
    confirmText2: '您正在批量删除',
    confirmText3: '条包裹规则',
    confirmText4: '的包裹规则',

    table: {
      // commodity: '商品编码',
      // commodityName: '商品名称',
      skuCoding: 'SKU编码',
      skuName: 'SKU名称',
      subcontract: '分包数量',
    },

    dialogForm: {
      title: '排除条件设置',
      condition: '符合该数量的寻源单拦截，寻源失败处理',
      formName: '单个SKU寻源数量',
      rulesValue: '请输入数量',
    },

    sendOut: {
        name: '商品名称',
        subcontract: '分包数量',
        title: '选择商品',
        commodity: '商品编码',
        commodityPlaceholder: '请输入商品编码',
        namePlaceholder: '请输入商品名称',
        renderHeader: '设置数量，则按指定数量分包,不设置数量则按指定商品，数量不限制',
        empty: '清 空',
        out2Title: '标题',
    },

    setMealSeparate: {
      chooseCombo: '选择套餐',
      combo: '套餐',
      comboCode: '套餐编码',
      comboName: '套餐名称',
      subcontract: '分包明细',
      commodityCode: '商品编码',
      commodityName: '商品名称',
      packageNumber: '套餐内数量',
      subcontractNumber: '分包数量'
  }
  }
};
